import styled from 'styled-components'

export default styled.img`
  height: 294px;
  width: 100%;
  object-fit: cover;
`
